import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Sitemap = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);

    const sitemapData = {
        English: [
            {
                category: "Home",
                links: [{ label: "Home", link: "/" }],
            },
            {
                category: "About Us",
                links: [
                    { label: "About Us", link: "/overview" },
                    { label: "Administrative Set-Up/ Administration", link: "/adminstructure" },
                    { label: "Awards", link: "/awards" },
                    { label: "Schemes & Projects", link: "/scheme" },
                ],
            },
            {
                category: "Department",
                links: [
                    { label: "Museums", link: "/museums" },
                    { label: "Monuments and Sites", link: "/monuments" },
                    { label: "Report Antiquities", link: "/reportantiquities" },
                ],
            },
            {
                category: "Permission & License",
                links: [
                    { label: "Film/Video Shooting", link: "/film-shooting" },
                    { label: "Gateway of India Event Permission", link: "/event-permission" },
                    { label: "Other State Protected Monuments Event Permission", link: "/monumenteventpermission" },
                    { label: "Development NOC", link: "/NOCDevelopement" },
                    { label: "Research Permissions", link: "/researchpermission" },
                ],
            },
            {
                category: "Preservation & Conservation",
                links: [
                    { label: "Preservation and Conservation", link: "/conversation" },
                ],
            },
            {
                category: "Resources",
                links: [
                    { label: "Legislations", link: "/legislations" },
                    { label: "GRs", link: "/gov-resolutions" },
                    { label: "Circulars", link: "/circulars" },
                    { label: "Court Orders", link: "/courtorder" },
                    { label: "Publication", link: "/publication" },
                    { label: "Excavations", link: "/excavations" },
                    { label: "Citizen Charter", link: "/citizen-charter" },
                    { label: "RTI", link: "/rti" },
                    { label: "Seniority List", link: "/senioritylist" },
                ],
            },
            {
                category: "Other",
                links: [
                    { label: "World Heritage", link: "/worldheritage" },
                    { label: "Gallery", link: "/gallery" },
                    { label: "Tenders", link: "/tenders" },
                    { label: "Dashboard", link: "/dashboard" },
                    { label: "Shop", link: "/shop" },
                    { label: "Contact Us", link: "/contact" },
                    { label: "Careers", link: "/careers" },
                    { label: "Events", link: "/events" },
                ],
            },
        ],
        मराठी: [
            {
                category: "मुख्यपृष्ठ",
                links: [{ label: "मुख्यपृष्ठ", link: "/" }],
            },
            {
                category: "परिचय",
                links: [
                    { label: "परिचय", link: "/overview" },
                    { label: "प्रशासकीय रचना / प्रशासन", link: "/adminstructure" },
                    { label: "पुरस्कार", link: "/awards" },
                    { label: "योजना आणि प्रकल्प", link: "/scheme" },
                ],
            },
            {
                category: "प्रशासन",
                links: [
                    { label: "संग्रहालये", link: "/museums" },
                    { label: "स्मारके व पुरास्थळे", link: "/monuments" },
                    { label: "नोंदणी करा - पुरावशेष, पुरावस्तू व पुरावास्तू", link: "/reportantiquities" },
                ],
            },
            {
                category: "परवानगी आणि परवाना",
                links: [
                    { label: "चित्रपट/व्हिडिओ शूटिंग", link: "/film-shooting" },
                    { label: "गेटवे ऑफ इंडिया कार्यक्रमाची परवानगी", link: "/event-permission" },
                    { label: "इतर राज्य संरक्षित स्मारकांच्या कार्यक्रमाची परवानगी", link: "/monumenteventpermission" },
                    { label: "विकास एनओसी", link: "/NOCDevelopement" },
                    { label: "संशोधन परवानग्या", link: "/researchpermission" },
                ],
            },
            {
                category: "जतन आणि संवर्धन",
                links: [
                    { label: "जतन आणि संवर्धन", link: "/conversation" },
                ],
            },
            {
                category: "संसाधने",
                links: [
                    { label: "अधिनियम", link: "/legislations" },
                    { label: "शासन निर्णय", link: "/gov-resolutions" },
                    { label: "परिपत्रक", link: "/circulars" },
                    { label: "न्यायालयीन आदेश", link: "/courtorder" },
                    { label: "प्रकाशने", link: "/publication" },
                    { label: "अन्वेषण आणि उत्खनन", link: "/excavations" },
                    { label: "नागरिकांची सनद", link: "/citizen-charter" },
                    { label: "माहितीचा अधिकार", link: "/rti" },
                    { label: "ज्येष्ठता सूची", link: "/senioritylist" },
                ],
            },
            {
                category: "इतर",
                links: [
                    { label: "जागतिक वारसा", link: "/worldheritage" },
                    { label: "दालन", link: "/gallery" },
                    { label: "निविदा", link: "/tenders" },
                    { label: "डॅशबोर्ड", link: "/dashboard" },
                    { label: "शॉप", link: "/shop" },
                    { label: "संपर्क साधा", link: "/contact" },
                    { label: "करिअर", link: "/careers" },
                    { label: "कार्यक्रम", link: "/events" },
                ],
            },
        ],
    };

    return (
        <div className="max-w-7xl mx-auto min-h-screen px-4 py-12">
            <div className="text-center mb-8">
                <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">        {selectedLang === "English" ? "Sitemap" : "साइटमॅप"}
                </h1>
            </div>
            <div className="flex flex-wrap justify-center gap-y-10">
                {sitemapData[selectedLang].map((section, idx) => (
                    <div
                        key={idx}
                        className="w-1/2 sm:w-1/4 lg:w-1/5 px-8"
                    >
                        <h2 className="font-bold text-base sm:text-lg mb-3 text-left">
                            {section.category}</h2>
                        <ul className="space-y-1 text-left">
                            {section.links.map((item) => (
                                <li key={item.link}>
                                    <Link
                                        to={item.link}
                                        className="text-blue-600 hover:underline text-[12px] sm:text-[14px] font-semibold block"
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Sitemap;
